<template>
  <el-container class="index-con">
    <div class="index-header" style="border-bottom: solid 1px #e6e6e6;">
      <navcon></navcon>
    </div>
    <div class="index-page"></div>
    <div style="padding-top: 40px;">
      <div class="main-con">
        <!-- 面包屑导航 -->
        <div class="breadcrumb">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">海量数据</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/index/classroom' }">课程</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/index/classroomDetails?id='+tid+'&type=1&path=1' }">课程详情</el-breadcrumb-item>
            <el-breadcrumb-item>{{itemName}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>

        <!-- 播放 -->
        <div class="broadcast">
          <p class="broadcast-title">{{itemName}}</p>
          <div class="broadcast-zx">
            <img src="../../assets/img/icon21.png">
            <span>在线教程</span>
          </div>
          
          <div class="video" style="position: relative;">
            <video
              ref="videoPlayer"
              :src="playAuth"
              :showPlay="true"
              @play="onPlay"
              @pause="onPause"
              @timeupdate="updateCurrentTime"
              @loadedmetadata="skipToTenSeconds"
              controls
              style="height: 400px;"
            >
            </video>
            <p>{{ courseItem.itemDesc }}</p>
          </div>
        </div>

        <!-- 考试列表 -->
        <div class="authentication" v-if="relationItemList.length>0">
          <div class="grades">
            <p class="grades-key">推荐课程</p>
            <ul>
              <li v-for="item,index in relationItemList" :key="index" @click="onExamDetails(item.id)">
                <div class="enroll-list-play">
                  <img class="enroll-list-img" :src="item.courseImg">
                  <img class="enroll-list-icon" src="../../assets/img/icon4.png">
                </div>
                <div class="grades-title">{{item.courseName}}</div>
                <div class="enroll-list-intotal">
                  <p class="enroll-list-intotal-period">共{{item.durationHour}}课时</p>
                  <p class="enroll-list-intotal-number">{{item.learnCount}}人学习</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <el-footer class="index-footer" style="height: auto; background-color: #f0f4f7;border-top: solid 1px #e6e6e6">
      <footers></footers>
    </el-footer>
  </el-container>
</template>
<script>
// 导入组件
import navcon from '../../components/navcon.vue'
import footers from '../../components/footers.vue'
import aliPlayer from "./AliPlayer.vue"
import 'aliyun-aliplayer/build/skins/default/aliplayer-min.css';
import { itemInfo,courseProcessSync } from '../../api/userMG'
export default {
  name: 'playback',
  // 注册组件
  components: {
    navcon,
    footers,
    aliPlayer
  },
  data() {
    return {
      tid:'',
      id:'',
      cover: '', //视频封面
      vid: '', //视频vid
      playAuth: '', //鉴权地址
      relationItemList:[],
      itemName:'',
      courseItem:{},
      course:0,
      learnDuration:0,
      timer: {}, // 定时器
      pauseTimer: {}, // 暂停定时器
      params:{},
      maxDuration: 0
    }
  },
  mounted() {
    // 监听视频播放
    this.$refs.videoPlayer.addEventListener("play", () => {
      this.openTimer();
    });
    // 监听视频暂停
    this.$refs.videoPlayer.addEventListener("pause", () => {
      this.closeTimer();
    });
  },
  created() {
    this.tid = this.$route.query.tid;
    this.id = this.$route.query.id;
    this.ifSign = this.$route.query.ifSign;
    this.maxDuration = this.$route.query.learnDuration; 
    this.getVideoData()
  },

  methods:{
    // 开启定时器
    openTimer() {
      this.timer = setInterval(() => {
        console.log("开启定时器")
        if(this.ifSign!=0){
          const loading = this.$loading({
            lock: true,
            text: '',
            spinner: ' ',
            background: 'rgba(255, 255, 255, 0)'
          });
          courseProcessSync(this.params).then(res => {
            loading.close();
          }).catch(err => {
            loading.close();
          })
        }
      }, 5000);
    },
    // 关闭定时器
    closeTimer() {
      clearInterval(this.timer);
      console.log("关闭定时器")
      if(this.ifSign!=0){
        const loading = this.$loading({
          lock: true,
          text: '',
          spinner: ' ',
          background: 'rgba(255, 255, 255, 0)'
        });
        courseProcessSync(this.params).then(res => {
          loading.close();
        }).catch(err => {
          loading.close();
        })
      }

      if(this.course == this.maxDuration){
        this.$message({
          message: '试看已结束，请购买课程后继续观看',
          type: 'warning',
          offset:100
        })
      }
    },
   
    updateCurrentTime(event) {
      this.course = event.target.currentTime;
      this.params = {
        courseItemId:this.id,
        current:event.target.currentTime
      }
      if(this.ifSign==0){
        const video = event.target;
        if (video.currentTime >= this.maxDuration) {
          video.pause();
          video.currentTime = this.maxDuration;
        }
      }
      
    },

    onPlay(e) {
      console.log('Video started playing.');
    },
    onPause(e) {
      console.log('Video paused.');
    },
    skipToTenSeconds(){
      const video = this.$refs.videoPlayer;
      if (video) {
        video.currentTime = this.learnDuration;
        video.play();
      }
    },
    
    getVideoData(){
      let params = {
        id:this.id
      }
      // const loading = this.$loading({
      //   lock: true,
      //   text: '加载中',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // });
      itemInfo(params).then(res => {
        console.log('课程视频',res.data);
        let playAuth = res.data.playUrl;
        this.playAuth = playAuth.split("?")[0];
        this.id = res.data.courseItem.id;
        this.vid = res.data.courseItem.videoId;
        this.itemName = res.data.courseItem.itemName;
        this.courseItem = res.data.courseItem;
        this.relationItemList = res.data.topCourseList;
        this.learnDuration = res.data.courseItem.learnDuration
        // loading.close();
      })
      // .catch(err => {
      //   loading.close();
      // })
    },

    onExamDetails(id){
      // this.id = id;
      // this.getVideoData();
      // this.$forceUpdate()

      this.$router.push({path:'/index/classroomDetails',query: { id: id, type:1 }})
      // this.$router.push({path:'/index/classroomDetails'})
    },
    
    played() {
      console.log("play callback");
    },
    play() {
      const player = this.$refs.player.instance;
      player && player.play();
    },
    pause() {
      const player = this.$refs.player.instance;
      player && player.pause();
    },
    
  }
}
</script>
<style scoped>
  @media (min-width: 1366px) {
    .main-con { 
        width: 1000px;
      }
    }
  @media (min-width: 1600px) {
    .main-con {
      width: 1300px;
    }
  }

  .main-con {
    margin: auto;
    padding-bottom: 40px;
  }
  .index-con {
    height: 100%;
    box-sizing: border-box;
    margin: auto;
  }

  .index-main{
    margin-left: 20px !important;
  }
  .index-header,
  .index-main,
  .index-footer {
    padding: 0px;
    height: auto;
    margin: 0; 
  }

  .broadcast{
    margin-top: 40px;
  }
  .broadcast-title{
    font-family: SourceHanSansCN;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    line-height: 18px;
  }
  .broadcast-zx{
    margin: 14px 0 24px;
    display: flex;
    align-items: center;
  }
  .broadcast-zx img{
    width: 10px;
    margin-right: 6px;
  }
  .broadcast-zx span{
    font-family: SourceHanSansCN;
    font-weight: 400;
    font-size: 12px;
    color: #B6B7BA;
    line-height: 12px;
  }
  .video{
    background: #fff;
    box-shadow: 0 0 20px rgba(222, 207, 207, 0.8);
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
  }
  .video video{
    width: 100%;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
  }
  .video p{
    padding: 20px 30px 30px;
    font-family: SourceHanSansCN;
    font-weight: 400;
    font-size: 13px;
    color: #666666;
    line-height: 28px;
  }

  .grades-key{
    font-family: SourceHanSansCN;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    line-height: 18px;
    border-left: 3px solid #F25902;
    padding-left: 10px;
    margin: 30px 0;
  }
  .grades ul{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  .grades ul li{
    background-color: #f8f9fb;
    width: 23.5%;
    box-shadow: 0 0 20px rgba(222, 207, 207, 0.8);
    border: 1px solid #e8e9ed;
    border-top: none;
    border-radius: 10px;
    margin-right: 17px;
    margin-bottom: 17px;
    transition: transform 0.3s ease-in-out; /* 动画持续时间和动画类型 */
    transform: translateY(0); /* 初始状态，不移动 */
    position: relative;
  }
  .grades ul li:nth-child(4){
    margin-right: 0;
  }
  .grades ul li:nth-child(8){
    margin-right: 0;
  }
  .grades ul li:nth-child(12){
    margin-right: 0;
  }
  .grades ul li:nth-child(16){
    margin-right: 0;
  }
  .grades ul li:hover{
    background-image: linear-gradient(bottom,#f9efe3 , #fff);
    transform: translateY(-10px)
  }
  
  .grades-title{
    margin:0 16px;
    padding: 10px 0;
    border-bottom: 1px solid #f0f0f0;
    font-size: 14px;
    font-weight: 500;
    color: black;
  }
  .grades ul li .text{
    font-size: 12px;
    color: #686868;
    margin-bottom: 28px;
  }
  .grades .button{
    width: 100%;
    height: auto;
  }
  

  .enroll-list-play{
    position: relative;
    cursor: pointer;
  }
  .enroll-list-icon{
    position: absolute;
    bottom: 20px;
    left: 20px;
    width: 10px !important;
    height: 10px !important;
    padding: 10px;
    border-radius: 50%;
    background-color: rgba(6, 6, 6, 0.3);
  }
  .enroll-list-img{
    width: 100%;
    /* height: 160px; */
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }
  .enroll-list-intotal{
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f2f2f2;
    padding: 10px;
  }
  .enroll-list-intotal-period{
    font-size: 12px;
    padding: 3px 10px;
    border-radius: 20px;
    background: #fcf2e8;
    color: #f16418;
    margin-right: 6px;
  }
  .enroll-list-intotal-number{
    font-size: 12px;
    padding: 2px 10px;
    border-radius: 20px;
    color: #f16418;
    border: 1px solid #fee5d9;
  }

</style>



// WEBPACK FOOTER //
// src/views/index/playback.vue